import * as React from "react";
import axios from "axios";
import {
  FaMapMarkerAlt,
  FaBriefcase,
  FaSearch,
  FaChevronDown,
} from "react-icons/fa";

// const jobData = [
//   {
//     index: 0,
//     title: "MERN Developer",
//     location: "Pune, India",
//     experience: "2-5 YOE",
//     category: "Technology",
//     description: "Join our development team to build scalable web applications using MongoDB, Express, React, and Node.js. Work on innovative solutions that drive sustainability and ESG initiatives.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/mern-developer"
//   },
//   {
//     index: 1,
//     title: "Senior QA Tester",
//     location: "Pune, India",
//     experience: "4-7 YOE",
//     category: "Technology",
//     description: "Lead quality assurance efforts for our software products. Design and execute test plans, identify bugs, and ensure high-quality deliverables that meet our standards.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/senior-qa-tester"
//   },
//   {
//     index: 2,
//     title: "Sales & Marketing Executive",
//     location: "Chennai, India",
//     experience: "2-5 YOE",
//     category: "Sales & Marketing",
//     description: "Drive business growth by identifying new opportunities, building client relationships, and promoting our sustainability and ESG solutions to enterprises across India.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/sales-and-marketing-executive"
//   },
//   {
//     index: 3,
//     title: "Manager – R&D/Technology Innovation",
//     location: "Pune, India",
//     experience: "6-10 YOE",
//     category: "Technology",
//     description: "Lead research and development initiatives, drive technology innovation, and oversee the development of cutting-edge solutions for sustainability and ESG platforms.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/manager-rdtechnology-innovation"
//   },
//   {
//     index: 4,
//     title: "Python Developer",
//     location: "Pune, India",
//     experience: "2-5 YOE",
//     category: "Technology",
//     description: "Develop robust backend systems and data processing solutions using Python. Work on analytics, automation, and integration projects that support our ESG and sustainability services.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/python-developer-932"
//   },
//   {
//     index: 5,
//     title: "Accounts Executive",
//     location: "Pune, India",
//     experience: "2-4 YOE",
//     category: "Finance",
//     description: "Manage accounting operations, financial reporting, and ensure compliance with accounting standards. Support financial planning and analysis for the organization.",
//     applyUrl: "https://nirantara-ecoventures.greythr.com/hire/jobs/account-executive"
//   },
// ];
const Description4 = [
  {
    title: "Responsibilities",
    content: [
      "Create and maintain sales and marketing dashboards with each activity recorded and measured for accountability. ",
      "Liaise internally with stakeholders for all marketing including inputs for social media, research papers, proposals and collateral. ",
      "Work with CMO and other managers to coordinate daily sync-ups for progress of sales pipeline",
      "Create minutes of meetings, follow up and ensure timely execution across internal and external parties. ",
      "Organising the prospect database, finding more sources for the same and executing to next level with cold calls and emailers. ",
      "Stay updated with latest news and reports on ESG and sustainability across industries. ",
    ],
  },
  {
    title: "What we are looking for",
    content: [
      "BBA/MBA or similar education",
      "Environmental studies or sustainability experience preferred  ",
      "Great communication skills ",
    ],
  },
  {
    title: "Competencies   ( Must Have)",
    content: [
      "Extremely Meticulous and organised",
      "Business oriented",
      "Critical thinking  ",
    ],
  },
  {
    title: "Good to have",
    content: [
      "Self-driven",
      "Curious ",
      "Go-getter ",
      "Target oriented ",
      "Data driven ",
    ],
  },
];

const Description5 = [
  {
    title: "Responsibilities",
    content: [
      "To assist to collect the data from clients and verify as per the requirements. .",
      "Data collection, Validation, Verification & Calculation for Carbon footprint emission (scope 1, 2 & 3)",
      "Data collection, Validation, Verification & Calculation for Life Cycle Assessment.",
      "To assist to prepare the draft reports for Carbon Footprint, Life Cycle Assessment & ESG as per the guidelines and frameworks.",
      "As and when required, contribute to administrative tasks for organization. ",
      "Read up and understand ESG Concepts and the various Frameworks associated with it.",
      "Build a Database of Prospects ",
      "Manage Cold Calling and Warm Calling ",
      "Identify top leads and establish contact with potential customers.",
      "Create, maintain, and update the sales pipeline ",
      "Manage account mapping, buyer personas, identify the right people in target accounts and set up meetings for sales heads.",
      "Research sectors & companies in target markets to manage sales & spot opportunities.",
      "Qualify accounts via direct/indirect validation before adding to the pipeline.",
      "Employ research skills and find information independently.",
      "Familiarise with the CRM applications of the company",
      "As and when required, contribute to administrative tasks for organization.",
      "This role will be performed onsite, and you are expected to work from office for the duration of your traineeship.",
    ],
  },
  {
    title: "What we are looking for",
    content: [
      "Environmental Engineer or MSc Environmental Science or B.E. (any branch) or relevant educational background",
    ],
  },
  {
    title: "Competencies  ( Must have )",
    content: [
      "Excellent written and verbal communication.",
      "Proficiency in MS office, Sales CRM and marketing automation tools",
      "Ability to work under pressure and ensure on-time delivery",
      "Exceptional interpersonal skills",
      "Responsible, reliable, and keen interest in learning.",
      "Good understanding of and experience in all elements of the marketing mix",
      "Analytical mindset with the ability to interpret data, generate insights, and make data-driven decisions to optimize marketing performance.",
      "Ability to work effectively in a fast-paced, collaborative environment, manage multiple projects simultaneously, and meet deadlines.",
    ],
  },
  {
    title: "Good to have",
    content: [
      "Willingness to go beyond self to take on larger goals",
      "A persuasive communicator",
      "Good secondary research skills and ability to find information independently",
      "Excellent presentation skills- making ppts as well as delivery",
    ],
  },
];

function JobCard({
  index,
  title,
  location,
  experience,
  category,
  description,
  details,
  applyUrl,
}) {
  const [showDescription, setShowDescription] = React.useState(false);

  const handleToggleDescription = () => {
    setShowDescription(!showDescription);
    document.body.style.overflow = showDescription ? "auto" : "hidden";
  };

  let jobDescription =
    index === 0 ? Description4 : index === 1 ? Description5 : [];

  const handleBackgroundClick = (e) => {
    if (e.target.classList.contains("blur_popup")) {
      setShowDescription(false);
    }
  };

  const [activeIndex, setActiveIndex] = React.useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const isSectionActive = (index) => activeIndex === index;

  const getArrowIcon = (index) => (isSectionActive(index) ? "🢖" : "🢗");

  const handleDownload = (index) => {
    const map = {
      0: "busDev",
      1: "MarketSpec",
    };

    const filePath = process.env.PUBLIC_URL + `/assets/${map[index]}.docx`;
    const link = document.createElement("a");
    link.href = filePath;
    link.download = `${map[index]}.docx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <article className="flex flex-col w-full p-6 bg-gray-50 border border-gray-300 rounded-lg">
      <h2 className="mb-4 text-xl font-bold text-black">{title}</h2>

      <div className="flex flex-wrap items-center gap-4 mb-4 text-sm text-gray-600">
        <div className="flex items-center gap-2">
          <FaMapMarkerAlt className="text-gray-400" />
          <span>{location}</span>
        </div>
        <div className="flex items-center gap-2">
          <FaBriefcase className="text-gray-400" />
          <span>{experience}</span>
        </div>
        <div className="flex items-center gap-2">
          <FaBriefcase className="text-gray-400" />
          <span>{category}</span>
        </div>
      </div>

      <p className="mb-6 text-sm leading-relaxed text-gray-700">
        {description}
      </p>

      <div className="flex gap-3 mt-auto">
        <a
          href={applyUrl || "mailto:hr@nirantara.solutions"}
          target={applyUrl ? "_blank" : undefined}
          rel={applyUrl ? "noopener noreferrer" : undefined}
          className="inline-flex items-center gap-2 text-sm font-medium text-blue-600 hover:text-blue-700 transition-colors"
        >
          Apply Now →
        </a>
        {details && (
          <button
            onClick={handleToggleDescription}
            className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-300 rounded hover:bg-gray-100 transition-colors"
          >
            View Details
          </button>
        )}
      </div>

      {details && showDescription && (
        <div
          onClick={handleBackgroundClick}
          className="blur_popup fixed top-0 left-0 w-full h-full flex justify-center items-center bg-gray-900 bg-opacity-50 lg:min-w-[600px] z-50"
        >
          <div className="bg-white p-8 rounded-lg max-w-md lg:min-w-[700px] h-96 lg:min-h-[500px] overflow-auto">
            <p
              className="cursor-pointer decoration-lime-600"
              style={{ float: "right" }}
              onClick={() => handleDownload(index)}
            >
              Download
            </p>
            <h3 className="mb-4 text-2xl font-semibold text-lime-600">
              Job Description
            </h3>
            <hr className="mb-4" />
            <div className="h-80 hidden_scrollbar">
              {jobDescription.map((section, index) => (
                <div key={index} className="border rounded">
                  <button
                    className="w-full px-4 py-2 text-xl font-semibold text-left focus:outline-none"
                    onClick={() => toggleAccordion(index)}
                  >
                    <span>{section.title}</span>
                    <span
                      style={{ color: isSectionActive(index) ? "#82be2c" : "" }}
                      className="float-right"
                    >
                      {getArrowIcon(index)}
                    </span>
                  </button>
                  <div className={isSectionActive(index) ? "block" : "hidden"}>
                    {Array.isArray(section.content) ? (
                      <ul className="mb-4 ml-6 list-disc">
                        {section.content.map((item, idx) => (
                          <li className="font-light" key={idx}>
                            {item}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="px-4 py-2 font-light">{section.content}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </article>
  );
}

function JobOpenings() {
  const [searchQuery, setSearchQuery] = React.useState("");
  const [locationQuery, setLocationQuery] = React.useState("");
  const [selectedCategory, setSelectedCategory] = React.useState("");
  const [selectedDate, setSelectedDate] = React.useState("");
  const [showCategoryDropdown, setShowCategoryDropdown] = React.useState(false);
  const [showDateDropdown, setShowDateDropdown] = React.useState(false);
  const categoryRef = React.useRef(null);
  const dateRef = React.useRef(null);
  const [jobData, setJobData] = React.useState([]);
  React.useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await axios.get(
          `https://api.nirantara.ai/api/career/website/getAll`
        );
        const data = response.data?.data || [];
        console.log(response.data?.data, "data");
        setJobData(data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
        setJobData([]);
      }
    };
    fetchJobs();
  }, []);

  // Close dropdowns when clicking outside
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryRef.current && !categoryRef.current.contains(event.target)) {
        setShowCategoryDropdown(false);
      }
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        setShowDateDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const categories = [
    "All Categories",
    "Technology",
    "Sales & Marketing",
    "Finance",
    "Sustainability & ESG",
    "Management",
  ];
  const postingDates = [
    "All Dates",
    "Last 24 hours",
    "Last week",
    "Last month",
  ];

  const filteredJobs = jobData.filter((job) => {
    const matchesSearch =
      !searchQuery ||
      job.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      job.description?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLocation =
      !locationQuery ||
      job.location?.toLowerCase().includes(locationQuery.toLowerCase());
    const matchesCategory =
      !selectedCategory ||
      selectedCategory === "All Categories" ||
      job.technology === selectedCategory;
    return matchesSearch && matchesLocation && matchesCategory;
  });

  const totalJobs = filteredJobs.length;

  return (
    <section
      className="w-full py-16 text-gray-800"
      style={{ paddingLeft: "8%", paddingRight: "8%" }}
    >
      <div className="max-w-[1400px] mx-auto">
        <h2 className="mb-8 text-4xl font-bold text-center text-black md:text-5xl">
          Current Openings
        </h2>

        {/* Search Interface */}
        <div className="mb-6">
          <div className="flex flex-col gap-4 mb-4 md:flex-row">
            <div className="flex-1">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Find Jobs
              </label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="Job title, Skill, keyword"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div className="flex-1">
              <label className="block mb-2 text-sm font-medium text-gray-700">
                Location
              </label>
              <div className="relative">
                <input
                  type="text"
                  placeholder="City, state, country"
                  value={locationQuery}
                  onChange={(e) => setLocationQuery(e.target.value)}
                  className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  <FaSearch />
                </button>
              </div>
            </div>
          </div>

          {/* Job Count and Filters */}
          <div className="flex flex-col items-start justify-between gap-4 mt-6 md:flex-row md:items-center">
            <p className="text-lg font-semibold text-gray-700">
              {totalJobs} open JOBS
            </p>
            <div className="flex gap-4">
              <div className="relative" ref={categoryRef}>
                <button
                  onClick={() => {
                    setShowCategoryDropdown(!showCategoryDropdown);
                    setShowDateDropdown(false);
                  }}
                  className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50"
                >
                  <span>{selectedCategory || "Categories"}</span>
                  <FaChevronDown className="text-xs" />
                </button>
                {showCategoryDropdown && (
                  <div className="absolute z-10 w-48 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    {categories.map((cat) => (
                      <button
                        key={cat}
                        onClick={() => {
                          setSelectedCategory(cat);
                          setShowCategoryDropdown(false);
                        }}
                        className="block w-full px-4 py-2 text-left hover:bg-gray-100 first:rounded-t-lg last:rounded-b-lg"
                      >
                        {cat}
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="relative" ref={dateRef}>
                <button
                  onClick={() => {
                    setShowDateDropdown(!showDateDropdown);
                    setShowCategoryDropdown(false);
                  }}
                  className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50"
                >
                  <span>{selectedDate || "Posting dates"}</span>
                  <FaChevronDown className="text-xs" />
                </button>
                {showDateDropdown && (
                  <div className="absolute z-10 w-48 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg">
                    {postingDates.map((date) => (
                      <button
                        key={date}
                        onClick={() => {
                          setSelectedDate(date);
                          setShowDateDropdown(false);
                        }}
                        className="block w-full px-4 py-2 text-left hover:bg-gray-100 first:rounded-t-lg last:rounded-b-lg"
                      >
                        {date}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Job Listings */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {filteredJobs.map((job, index) => (
            <JobCard
              key={job._id || index}
              index={job.index}
              title={job.title}
              location={job.location}
              experience={`${job.yearOfExperience} YOE`}
              category={job.technology}
              description={job.description}
              details={false}
              applyUrl={job.applyLink}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default JobOpenings;
